function SectionItem(_props) {
  return null;
}
export {
  SectionItem
};
//# sourceMappingURL=SectionItem.js.map
